import type { AgentId } from '../types/anna';
import type { CardKind } from '../types/stage';

/** Which agent each summoned card belongs to — colours its filament back to Anna. */
export const cardAgents: Record<CardKind, AgentId> = {
  vandaag: 'agenda',
  vannacht: 'initiatief',
  koffie: 'huis',
  deur: 'huis',
  weer: 'initiatief',
  route: 'agenda',
  lisa: 'initiatief',
  verwarming: 'huis',
  licht: 'huis',
  klimaat: 'huis',
  mailDraft: 'mail',
  geweigerd: 'huis',
};
